import { faDollarCircle } from '@fortawesome/pro-solid-svg-icons/faDollarCircle'
import { faEarthAmericas } from '@fortawesome/pro-solid-svg-icons/faEarthAmericas'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers'
import Icon from '@space-core/components/icon'
import useTranslation from '@space-core/hooks/useTranslation'

import {
  CommunityAsProduct,
  ContainerExclusiveCommunity,
  ContainerOpenCommunity,
  ContainerProductCommunity,
  ContainerPublicCommunity,
  ExclusiveCommunity,
  OpenCommunityLabel,
  PublicCommunityLabel
} from './styles'
import type { CommunityBadgeProps } from './types'

import { COMMUNITY_TYPE } from '../../constants'

const CommunityBadge = ({ type }: CommunityBadgeProps) => {
  const { t } = useTranslation()

  return (
    <>
      {type === COMMUNITY_TYPE.EXCLUSIVE && (
        <ContainerExclusiveCommunity className='_d-flex _py-0 _px-2 _align-items-center _mr-1'>
          <Icon width={12} height={12} className='_mr-1' color='var(--yellow)' icon={faStar} />
          <ExclusiveCommunity className='_mb-0 _text-1'>
            {t('configuration_sidebar.access_and_privacy.exclusive_access.title_v2')}
          </ExclusiveCommunity>
        </ContainerExclusiveCommunity>
      )}
      {type === COMMUNITY_TYPE.PAID && (
        <ContainerProductCommunity className='_d-flex _py-0 _px-2 _align-items-center _mr-1'>
          <Icon
            width={12}
            height={12}
            className='_mr-1'
            color='var(--green-darker)'
            icon={faDollarCircle}
          />
          <CommunityAsProduct className='_mb-0 _text-1'>
            {t('configuration_sidebar.access_and_privacy.paid_access.title_v2')}
          </CommunityAsProduct>
        </ContainerProductCommunity>
      )}
      {type === COMMUNITY_TYPE.OPEN && (
        <ContainerOpenCommunity className='_d-flex _py-0 _px-2 _align-items-center _mr-1'>
          <Icon width={12} height={12} className='_mr-1' color='var(--blue-dark)' icon={faUsers} />
          <OpenCommunityLabel className='_mb-0 _text-1'>
            {t('configuration_sidebar.access_and_privacy.open_access.title_v2')}
          </OpenCommunityLabel>
        </ContainerOpenCommunity>
      )}
      {type === COMMUNITY_TYPE.PUBLIC && (
        <ContainerPublicCommunity className='_d-flex _py-0 _px-2 _align-items-center _mr-1'>
          <Icon
            width={12}
            height={12}
            className='_mr-1'
            color='var(--gray-700)'
            icon={faEarthAmericas}
          />
          <PublicCommunityLabel className='_mb-0 _text-1'>
            {t('configuration_sidebar.access_and_privacy.public_access.title')}
          </PublicCommunityLabel>
        </ContainerPublicCommunity>
      )}
    </>
  )
}

export default CommunityBadge
